<template>
    <navbar position="fixed"
            type="primary"
            menu-classes="ml-auto">
        <template slot-scope="{toggle, isToggled}">
            <router-link v-popover:popover1 class="navbar-brand" to="/home">
                <img src="/img/homepage/logo-2.png" width="90" alt="AightBet">
            </router-link>
        </template>
        <template slot="navbar-menu">
            <li class="nav-item">
                <a class="nav-link" href="/#/australiaReview">
                        <p>AUSTRALIA REVIEWS</p>
                </a>
            </li>
            <!-- <li class="nav-item">
                <a class="nav-link" href="/#/usaReview">
                        <p>USA REVIEWS</p>
                </a>
            </li> -->
            <!-- {{loggedIn}} + {{this.$store.state.models.logedIn}} -->
            <div @mouseover="onOver" @mouseleave="onLeave">
            <us-drop-down class="item-p" tag="li" ref="dropdown" title="USA REVIEWS">
                <nav-link class="dropdown-item" to="/usaReviewDetail/NJ">
                    NJ Sports Betting
                </nav-link>
                <nav-link class="dropdown-item" to="/usaReviewDetail/PA">
                    PA Sports Betting
                </nav-link>
                <nav-link class="dropdown-item" to="/usaReviewDetail/Colorado">
                    Colorado Sports Betting
                </nav-link>
                <nav-link class="dropdown-item" to="/usaReviewDetail/Illinois">
                    Illinois Sports Betting
                </nav-link>
                <nav-link class="dropdown-item" to="/usaReviewDetail/Indiana">
                    Indiana Sports Betting
                </nav-link>
                <nav-link class="dropdown-item" to="/usaReviewDetail/Iowa">
                    Iowa Sports Betting
                </nav-link>
                <nav-link class="dropdown-item" to="/usaReviewDetail/Michigan">
                    Michigan Sports Betting
                </nav-link>
                <nav-link class="dropdown-item" to="/usaReviewDetail/Mississippi">
                    Mississippi Sports Betting
                </nav-link>
                <nav-link class="dropdown-item" to="/usaReviewDetail/Nevada">
                    Nevada Sports Betting
                </nav-link>
                <nav-link class="dropdown-item" to="/usaReviewDetail/NewHampshire">
                    New Hampshire Sports Betting
                </nav-link>
                <nav-link class="dropdown-item" to="/usaReviewDetail/NewYork">
                    New York Sports Betting
                </nav-link>
                <nav-link class="dropdown-item" to="/usaReviewDetail/Oregon">
                    Oregon Sports Betting
                </nav-link>
                <nav-link class="dropdown-item" to="/usaReviewDetail/Tennessee">
                    Tennessee Sports Betting
                </nav-link>
                <nav-link class="dropdown-item" to="/usaReviewDetail/Virginia">
                    Virginia Sports Betting
                </nav-link>
                <nav-link class="dropdown-item" to="/usaReviewDetail/WestVirginia">
                    West Virginia Sports Betting
                </nav-link>
            </us-drop-down>
            </div>
            <div @mouseover="onOverT" @mouseleave="onLeaveT">
            <pr-drop-down class="item-p" tag="li" ref="dropdownT" title="Predictions">
                <nav-link class="dropdown-item" to="/predictionSports/Soccer">
                    Soccer
                </nav-link>
                <nav-link class="dropdown-item" to="/predictionSports/AFL">
                    AFL
                </nav-link>
                <nav-link class="dropdown-item" to="/predictionSports/NFL">
                    NFL
                </nav-link>
                <nav-link class="dropdown-item" to="/predictionSports/NBA">
                    NBA
                </nav-link>
                <nav-link class="dropdown-item" to="/predictionSports/NRL">
                    NRL
                </nav-link>
                <nav-link class="dropdown-item" to="/predictionSports/Tennis">
                    Tennis
                </nav-link>
                <nav-link class="dropdown-item" to="/predictionSports/UFC">
                    UFC
                </nav-link>
                <nav-link class="dropdown-item" to="/predictionSports/HorseRacing">
                    Horse Racing
                </nav-link>
                <nav-link class="dropdown-item" to="/predictionSports/NHL">
                    NHL
                </nav-link>
                <nav-link class="dropdown-item" to="/predictionSports/MLB">
                    MLB
                </nav-link>
                <nav-link class="dropdown-item" to="/predictionSports/CollegeBasketball">
                    College Basketball
                </nav-link>
                <nav-link class="dropdown-item" to="/predictionSports/CollegeFootball">
                    College Football
                </nav-link>
            </pr-drop-down>
            </div>
            <!-- <li class="nav-item">
                <a class="nav-link" href="/#/prediction">
                        <p>PREDICTIONS</p>
                </a>
            </li> -->
            <!-- <li class="nav-item">
                <a class="nav-link" href="/#/evPunting">
                        <p>+EV PUNTING</p>
                </a>
            </li> -->
             <li class="nav-item">
                <a class="nav-link" href="/#/theSystem">
                        <p>The System</p>
                </a>
            </li>
            <!-- <li class="nav-item">
                <a class="nav-link" href="/#/freeCompetions">
                        <p>FREE COMPETITIONS</p>
                </a>
            </li> -->
            <li class="nav-item">
                <a class="nav-link" href="/#/blog">
                        <p>BLOG</p>
                </a>
            </li>
             <!-- <li class="nav-item">
                <a class="nav-link" href="#pablo">
                        <p>MEMBERS LOGIN</p>
                </a>
            </li> -->
            <div  v-if="loggedIn == false">
                <li class="nav-item">
                    <nav-link class="nav-link wh-col btn btn-primary"
                    to="/manageSubscription">
                        <p>Manage/Cancel Subscription</p>
                    </nav-link>
                </li>    
            </div>
            <div v-else-if="loggedIn == true" >
                <li class="nav-item">
                    <n-button class="nav-link btn btn-primary" @click="logout" type="primary">Logout</n-button>
                </li>  
            </div>
            
            

        </template>
    </navbar>
</template>

<script>
  import { DropDown, PrDropDown, UsDropDown, EvDropDown, NavbarToggleButton, Navbar, NavLink } from '@/components';
  import { Popover } from 'element-ui'
  import MainFooter from '@/layout/MainFooter';
  import db from '../components/Firebase/firebaseInit'
  import firebase from 'firebase';

  export default {
    name: 'main-navbar',
    components: {
      DropDown,
      PrDropDown,
      UsDropDown,
      EvDropDown,
      Navbar,
      NavLink,
      NavbarToggleButton,
      [Popover.name]: Popover
    },
  data: {
    loggedIn: false,
    isHovering: false
  },
  computed: {
    loggedIn () {
      return this.$store.state.models.logedIn
      // Or return basket.getters.fruitsCount
      // (depends on your design decisions).
    }
  },
    methods: {
      onOver() {
        this.$refs.dropdown.isOpen = true;
      },
      onLeave() {
        this.$refs.dropdown.isOpen = false;
      },
      onOverT() {
        this.$refs.dropdownT.isOpen = true;
      },
      onLeaveT() {
        this.$refs.dropdownT.isOpen = false;
      },
      onOverE() {
        this.$refs.dropdownE.isOpen = true;
        
      },
      onLeaveE() {
        this.$refs.dropdownE.isOpen = false;
        
      },
    logout() {
        this.$store.state.models.logedIn = false;
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push('/home');
        });
    }
    }
  }
</script>

<style scoped>
p{
    font-size: 14px !important;
    font-weight: 600 !important;
    text-align: center !important;
}
.item-p{
 font-size: 19px !important;
 font-weight: 600 !important;
}
.bg-primary {
    background-color: #000000 !important;
}
.wh-col{
    color: #fff;
}

</style>
